<template>
  <SideMenu
    class="patient-profile-modal"
    :value="isVisible"
    :side-menu-width="400"
    use-alternate-content-template
    @side-menu:click-close="handleCloseModal"
  >
    <ModalLayout
      close-to
      limit-title
      :header-padding-x-step="6"
      :title="`${$i18next.t('Пациент', options)} ${patientData.title}`"
      :has-fixed-btn="patientData.isLoaded"
      @modal:back="handleCloseModal"
    >
      <PatientProfileModalContent
        btn-fixed-float
        :patient-data="patientData"
        @modal:close="handleCloseModal"
      />
    </ModalLayout>
  </SideMenu>
</template>

<script>
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'
import ModalLayout from 'www/vue_components/mobile/core/ModalLayout.vue'
import PatientProfileModalContent from 'www/vue_components/common/PatientProfile/components/common/PatientProfileModalContent.vue'
import getUserLanguage from 'src/utils/getUserLanguage'

export default {
  name: 'PatientProfileModal',
  components: {
    SideMenu,
    ModalLayout,
    PatientProfileModalContent,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    patientData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    options: { ns: getUserLanguage() },
  }),
  methods: {
    handleCloseModal() {
      this.$emit('modal:close')
    },
  },
}
</script>
